import { FRAMERATE_NAMES, framerate } from "@infoflyt/shared/timecode";
import { useSession } from "../../state/SessionProvider";
import { confirm } from "../../components/haptics";

/**
 * Framerate paa «privat».
 *
 * Finnes bare for privat. En produksjons framerate settes av prodleder paa
 * nettflata og er en egenskap ved produksjonen — to regier paa samme
 * produksjon maa regne likt, ellers peker postene deres ulike steder i
 * materialet. Privat har ingen prodleder, saa der eier brukeren den selv.
 *
 * Tidskoden som VISES staar stille gjennom byttet: ankeret regnes om til den
 * nye takten. Se settFramerate.
 */
export function FrameratePane(): JSX.Element {
  const { production, settFramerate } = useSession();

  return (
    <>
      <span className="mono" style={{ fontSize: 12, lineHeight: 1.6, color: "var(--ink-dim)" }}>
        Gjelder bare privat. Tidskoden du ser står stille — ankeret regnes om
        til den nye takten, så postene du har beholder klokkeslettet sitt.
      </span>

      <div className="menu__group">
        {FRAMERATE_NAMES.map((navn) => {
          const valgt = navn === production.framerate;
          return (
            <button
              key={navn}
              type="button"
              className="menu__row"
              aria-current={valgt}
              onClick={() => {
                if (valgt) return;
                confirm();
                settFramerate(navn);
              }}
            >
              <span style={{ color: valgt ? "var(--tc)" : undefined }}>{navn} fps</span>
              <span className="menu__rowvalue">
                {/* Drop-frame finnes bare ved 29.97 og 59.94, og det er verdt
                    aa si naar man staar og velger. Se docs/04-timecode.md. */}
                {framerate(navn).supportsDropFrame ? "drop-frame mulig" : ""}
                {valgt ? " · valgt" : ""}
              </span>
            </button>
          );
        })}
      </div>
    </>
  );
}
